import Layout from 'components/layout/Layout'
import { useAuth } from 'contexts/AuthContext'
import { useUser } from 'contexts/UserContext'
import Dashboard from 'pages/Dashboard/Dashboard'
import Login from 'pages/Login/Login'
import Logout from 'pages/Login/Logout'
import PropTypes from 'prop-types'
import { ToastContainer } from 'react-toastify'
import { Redirect, Route, Switch } from 'wouter'
import CirculationViewDetail from './Incident/Circulation/CirculationViewDetail'
import CirculationViewGrid from './Incident/Circulation/CirculationViewGrid'
import InjuredViewDetail from './Incident/Injured/InjuredViewDetail'
import InjuredViewGrid from './Incident/Injured/InjuredViewGrid'
import RequestReset from './Login/RequestReset'
import ResetPassword from './Login/ResetPassword'
import MapViewDetail from './Map/MapViewDetail'
import NotFound from './NotFound/NotFound'
import UserViewDetail from './User/UserViewDetail'
import UserViewGrid from './User/UserViewGrid'

// Rutas privadas que se pueden usar si se ha iniciado sesión:
const PrivateRoute = ({ isLoggedIn, allowedRoles, ...props }) => {
  const { user } = useUser() // Get user roles from context

  if (!isLoggedIn) {
    return <Redirect to="/login" />
  }

  // Check if user's roles include any of the allowed roles
  if (allowedRoles && !allowedRoles.includes(user.role_id)) {
    return <Redirect to="/page-not-found" /> // Redirect if user is unauthorized
  }

  return (
    <Layout>
      <Route {...props} />
    </Layout>
  )
}

// Ruta 'LOG IN' que se usa si no se ha iniciado sesión:
const LoginRoute = ({ isLoggedIn, ...props }) =>
  isLoggedIn ? <Redirect to="/" /> : <Route {...props} />

export default function App() {
  const { user } = useUser()

  // Hook para gestionar el token
  const { token } = useAuth()

  const isLoggedIn =
    user &&
    user !== undefined &&
    user !== null &&
    token &&
    token !== undefined &&
    token !== null

  return (
    <>
      <Switch>
        {/* INICIO SESIÓN / CIERRE SESIÓN */}
        <LoginRoute isLoggedIn={isLoggedIn} path="/login" component={Login} />

        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/logout"
          component={Logout}
          allowedRoles={[1, 2]}
        />
        {/* FIN INICIO SESIÓN / CIERRE SESIÓN */}

        {/* RESTABLECER CONTRASEÑA */}
        <LoginRoute
          isLoggedIn={isLoggedIn}
          path="/request-reset"
          component={RequestReset}
        />

        <LoginRoute
          isLoggedIn={false}
          path="/reset-password/:token"
          component={ResetPassword}
        />
        {/* RESTABLECER CONTRASEÑA */}

        {/* PANEL PRINCIPAL */}
        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/"
          component={Dashboard}
          allowedRoles={[1, 2]}
        />
        {/* FIN PANEL PRINCIPAL */}

        {/* SINIESTROS TUS (CIRCULACIÓN / LESIONADOS) */}
        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/tus-incidents/circulation/grid"
          component={CirculationViewGrid}
          allowedRoles={[1, 2]}
        />

        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/:view/circulation/:id"
          component={CirculationViewDetail}
          allowedRoles={[1, 2]}
        />

        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/tus-incidents/injured/grid"
          component={InjuredViewGrid}
          allowedRoles={[1, 2]}
        />

        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/:view/injured/:id"
          component={InjuredViewDetail}
          allowedRoles={[1, 2]}
        />
        {/* FIN SINIESTROS TUS (CIRCULACIÓN / LESIONADOS) */}

        {/* MAPAS (CIRCULACIÓN / LESIONADOS) */}
        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/maps/:type"
          component={MapViewDetail}
          allowedRoles={[1, 2]}
        />
        {/* FIN MAPAS (CIRCULACIÓN / LESIONADOS) */}

        {/* USUARIOS */}
        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/users/grid"
          component={UserViewGrid}
          allowedRoles={[1]}
        />

        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/users/:id"
          component={UserViewDetail}
          allowedRoles={[1]}
        />
        {/* FIN USUARIOS */}

        {/* 404 - NOT FOUND */}
        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="*"
          component={NotFound}
          allowedRoles={[1, 2]}
        />
        {/* FIN 404 - NOT FOUND */}
      </Switch>

      {/* 
        'ToastContainer' es un contenedor para mostrar mensajes flotantes, generalmente se usa para mensajes de éxito o error tras llamadas a la API. 
        No mover de aquí, ya que aquí funciona correctamente. Si lo pones en otro lugar de la app el botón de cerrar o las animaciones no funcionan. 
        Los toasts se crean y se referencian automáticamente a este componente para mostrarse. 
        Para más info: https://fkhadra.github.io/react-toastify/introduction/
      */}
      <ToastContainer />
    </>
  )
}

PrivateRoute.propTypes = {
  isLoggedIn: PropTypes.bool,
  allowedRoles: PropTypes.array
}

LoginRoute.propTypes = {
  isLoggedIn: PropTypes.bool
}
